import { useStyles } from './style';
import CustomLayout from 'component/layout/custom_layout';
import ConnectedAccountsCard from './ConnectedAccountsCard';
import CalendlyIcon from '../../assets/svg/calendly_logo.svg';
import { useHistory, useLocation } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { useMutation, useQuery } from '@apollo/client';
import { MY_CONNECTED_APPS } from 'graph_ql/connected_apps/queries';
import { useEffect, useState } from 'react';
import { ConnectedApp } from './types';
import config from 'config';
import { DELETE_CONNECTED_APP } from 'graph_ql/connected_apps/mutations';
import { ToastType } from 'constants/index';
import StandardPopup from 'component/StandardPopup';
import { CircularProgress } from '@material-ui/core';

const ConnectedAccounts = () => {
    const classes = useStyles();
    const history = useHistory();
    // const [connectedApps, setConnectedApps] = useState<ConnectedApp[]>();
    const [calendlyAccount, setCalendlyAccount] = useState<ConnectedApp | null>();
    const { noCalendlyEventTypes } = useLocation<{ noCalendlyEventTypes: boolean }>().state ?? {};
    const [modalShow, setModalShow] = useState({
        show: false,
        title: '',
        content: '',
        button1: '',
        button2: '',
        type: '',
        closeButton: true,
        firstButtonClick: () => {},
        secondButtonClick: () => {},
    });
    const { loading } = useQuery(MY_CONNECTED_APPS, {
        onCompleted(response) {
            // setConnectedApps(response?.myConnectedApps);
            response?.myConnectedApps.filter((app: ConnectedApp) => {
                if (app.app === 'CALENDLY') {
                    setCalendlyAccount(app);
                }
                return true;
            });
        },
        fetchPolicy: 'no-cache',
    });
    const [deleteConnectedApp, { loading: deleteLoading }] = useMutation(DELETE_CONNECTED_APP, {
        onCompleted() {
            setCalendlyAccount(null);
        },
    });
    const handleCalendlyConnect = () => {
        window.location.replace(config.calendlyOauthLoginUrl);
    };
    const handleCalendlyDisconnect = () => {
        setModalShow({
            show: true,
            title: 'Disconnect Calendly ?',
            content:
                'If you disconnect Calendly from Taffi, customers will not be able to schedule styling sessions with you.',
            button1: 'Cancel',
            button2: 'Disconnect',
            type: ToastType.Warning,
            closeButton: true,
            firstButtonClick: () => setModalShow({ ...modalShow, show: false }),
            secondButtonClick: () => {
                deleteConnectedApp({
                    variables: {
                        input: {
                            id: calendlyAccount?.id,
                        },
                    },
                });
                setModalShow({ ...modalShow, show: false });
            },
        });
    };
    useEffect(() => {
        if (noCalendlyEventTypes && calendlyAccount?.id) {
            deleteConnectedApp({
                variables: {
                    input: {
                        id: calendlyAccount?.id,
                    },
                },
            });
            setModalShow({
                show: true,
                title: 'There are no event types found on your Calendly',
                content: 'Please go to your Calendly account, create an event type and then retry connecting Calendly.',
                button1: 'Open Calendly',
                button2: 'Cancel',
                type: ToastType.Warning,
                closeButton: true,
                firstButtonClick: () => {
                    window.open(config.createCalendlyEventUrl);
                    setModalShow({ ...modalShow, show: false });
                },
                secondButtonClick: () => setModalShow({ ...modalShow, show: false }),
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [noCalendlyEventTypes, calendlyAccount]);

    return (
        <>
            <CustomLayout title="Connected Accounts" showHeader>
                {loading || deleteLoading ? (
                    <div className={classes.loadingSection}>
                        <span className={classes.loadingText}>
                            Loading Accounts... &nbsp;
                            <CircularProgress style={{ width: 20, height: 20, color: 'black' }} />
                        </span>
                    </div>
                ) : (
                    <div className={classes.cardContainer}>
                        <ConnectedAccountsCard
                            accountDetails={{
                                title: 'Calendly',
                                icon: CalendlyIcon,
                                description:
                                    'By connecting your calendly account, You can allow consumers to schedule styling sessions with you.',
                            }}
                            isConnected={calendlyAccount?.status ? true : false}
                            accountData={{
                                email: calendlyAccount?.email,
                                eventName: calendlyAccount?.eventName || 'Select to schedule',
                            }}
                            onSelectAccount={() => history.push(PATH.CALENDLY_MEETINGS)}
                            onConnectButtonClick={handleCalendlyConnect}
                            onDisconnectButtonClick={handleCalendlyDisconnect}
                        />
                        <hr className={classes.cardBorder} />
                        {/* <ConnectedAccountsCard
                            accountDetails={{
                                title: 'Instagram',
                                subTitle: 'Coming Soon',
                                icon: InstagramIcon,
                                description: '',
                            }}
                            buttonDisabled
                        />
                        <hr className={classes.cardBorder} />
                        <ConnectedAccountsCard
                            accountDetails={{
                                title: 'SnapChat',
                                subTitle: 'Coming Soon',
                                icon: SnapchatIcon,
                                description: '',
                            }}
                            buttonDisabled
                        /> */}
                    </div>
                )}
                <StandardPopup
                    show={modalShow.show}
                    onHide={() => setModalShow({ ...modalShow, show: false })}
                    title={modalShow.title}
                    content={modalShow.content}
                    button1={modalShow.button1}
                    button2={modalShow.button2}
                    onFirstButtonClick={modalShow.firstButtonClick!}
                    onSecondButtonClick={modalShow.secondButtonClick!}
                    type={modalShow.type as any}
                    closeButton={modalShow.closeButton}
                />
            </CustomLayout>
        </>
    );
};

export default ConnectedAccounts;
